import React, { FC } from 'react'

import { IconEngineerProps } from './IconEngineer.types'
import * as Styled from './styles/IconEngineer.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEngineer: FC<IconEngineerProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEngineerProps['size'],
  isResponsive = false,
}: IconEngineerProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M22.512 18.105 40.328 35.92a3 3 0 0 1 0 4.25 3 3 0 0 1-4.25 0L18.27 22.347m-3.285 6.426L7.837 35.92a3 3 0 0 0 0 4.25 3.001 3.001 0 0 0 4.25 0l7.148-7.148'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m13.517 38.725 5.665-5.665a3 3 0 0 0 0-4.25 3 3 0 0 0-4.25 0l-5.657 5.673'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M7.775 11.852A8 8 0 0 0 18.25 22.34m4.25-4.24A8 8 0 0 0 12.02 7.6' stroke='#fff' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M26.293 21.885 40.294 7.88M19.33 28.843l2.723-2.72'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m12 7.555 3.885 4.045a1 1 0 0 1 .28.693V15a1 1 0 0 1-1 1h-2.807a1 1 0 0 1-.708-.293l-3.862-3.872'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEngineer
